import { HOME_ROUTE } from 'routes/constants'

// Theme Names
export const STUDIO = 'studio'
export const FEATURES = 'features'
export const FEATUREDWORK = 'featuredwork'
export const MUSTARD = 'mustard'
export const QVC = 'qvc'
export const BRCC = 'brcc'
export const PLEXUS = 'plexus'
export const ALICE_AND_OLIVIA = 'aliceolivia'
export const CREATIVELY = 'creatively'
export const GEMINI = 'gemini'
export const BETQL = 'betql'
export const LIVE = 'live'
export const ALKEME = 'alkeme'
export const SPIRITUNE = 'spiritune'
export const MOE = 'moe'
export const SOMEWHERE_GOOD = 'somewhere-good'
export const FAHLO = 'fahlo'
export const REFER = 'refer'
export const FOOTER = 'footer'
export const PROJECT_FOOTER = 'project-footer'
export const DEFAULT = 'default'

// Theme Palette Colors
export const THEME_GREY = 'grey'
export const THEME_WHITE = 'white'
export const THEME_BASE_WHITE = 'base-white'
export const THEME_BASE_BLACK = 'base-black'
export const THEME_RED = 'red'
export const THEME_DARK_BLUE = 'dark-blue'
export const THEME_ORANGE = 'orange'
export const THEME_DARK = 'dark'
export const THEME_TRANSPARENT = 'transparent'

// Portfolio Themes
export const THEME_LIVE_PURPLE = 'live-purple'
export const THEME_LIVE_PURPLE_DARK = 'live-purple-dark'
export const THEME_LIVE_WHITE = 'live-white'

export const THEME_ALKEME_BEIGE = 'alkeme-beige'
export const THEME_ALKEME_GREEN = 'alkeme-green'
export const THEME_ALKEME_DARK = 'alkeme-dark'

export const THEME_SPIRITUNE_WHITE = 'spiritune-white'
export const THEME_SPIRITUNE_BEIGE = 'spiritune-beige'
export const THEME_SPIRITUNE_WHITE_GRADIENT = 'spiritune-white-gradient'
export const THEME_SPIRITUNE_BEIGE_GRADIENT = 'spiritune-beige-gradient'
export const THEME_SPIRITUNE_BEIGE_WHITE_TEXT = 'spiritune-beige-white-text'

export const THEME_CREATIVELY_WHITE = 'creatively-white'
export const THEME_CREATIVELY_GREEN = 'creatively-green'

export const THEME_MUSTARD_GREY = 'mustard-grey'
export const THEME_MUSTARD_WHITE = 'mustard-white'
export const THEME_MUSTARD_PURPLE = 'mustard-purple'
export const THEME_MUSTARD_GRADIENT = 'mustard-gradient'
export const THEME_MUSTARD_TRANSPARENT = 'mustard-transparent'

export const THEME_QVC_BLUE = 'qvc-blue'
export const THEME_QVC_ORANGE = 'qvc-orange'
export const THEME_QVC_ORANGE_LIGHT = 'qvc-orange-light'
export const THEME_QVC_WHITE = 'qvc-white'

export const THEME_BRCC_YELLOW = 'brcc-yellow'

export const THEME_PLEXUS_BLUE = 'plexus-blue'
export const THEME_PLEXUS_LIGHT_BLUE = 'plexus-light-blue'
export const THEME_PLEXUS_GREY = 'plexus-grey'
export const THEME_PLEXUS_GREEN = 'plexus-green'

export const THEME_A_O_GREY = 'a-o-grey'

export const THEME_MOE_GREY = 'moe-grey'
export const THEME_MOE_WHITE = 'moe-white'
export const THEME_MOE_PINK = 'moe-pink'
export const THEME_MOE_BLUE = 'moe-blue'
export const THEME_MOE_GREEN = 'moe-green'
export const THEME_MOE_YELLOW = 'moe-yellow'
export const THEME_MOE_PURPLE = 'moe-purple'

export const THEME_SOMEWHERE_GOOD_GREEN = 'somewhere-good-green'
export const THEME_SOMEWHERE_GOOD_WHITE = 'somewhere-good-white'
export const THEME_SOMEWHERE_GOOD_BLUE = 'somewhere-good-blue'

export const THEME_REFER_GREEN = 'refer-green'

export const THEME_BETQL_GREEN = 'betql-green'
export const THEME_BETQL_BLUE = 'betql-blue'

export const STUDIO_GREY = '#1e1e1e'
export const STUDIO_WHITE = '#F5F1F1'
export const STUDIO_RED = '#FB3640'
export const STUDIO_MID_BLUE = '#247BA0'
export const STUDIO_DARK_BLUE = '#0A2463'

export const BASE_BLACK = '#000'
export const BASE_WHITE = '#fff'

export const BETQL_BLUE = '#00214D'
export const REFER_GREEN = '#B8FF8C'
export const MUSTARD_ORANGE = '#ffa800'
export const MUSTARD_BLUE = '#1f1d32'
export const LIVE_PURPLE = '#4f25c6'
export const CREATIVELY_GREY = '#151515'
export const ALKEME_BEIGE = '#ede7d9'
export const SPIRITUNE_BLUE = '#006ac5'
export const QVC_ORANGE = '#F67963'
export const BRCC_YELLOW = '#F6B51A'
export const PLEXUS_BLUE = '#4284F3'
export const QVC_PINK = '#f47963'
export const GEMINI_BLUE = '#02213B'
export const BRCC_MUSTARD = '#f6b518'
export const FAHLO_CREAM = '#ffefdc'
export const FAHLO_BLUE = '#22526c'
export const EVERYGENE_RED = '#f3562b'
export const MOE_GRAY = '#272727'
export const MOE_CREAM = '#fff5ec'
export const BREAKR_YELLOW = '#ffea00'
export const UPSELL_BLUE = '#cff6ff'
export const UPSELL_DARK_BLUE = '#232550'
export const COVER_BLUE = '#5cc8ff'
export const COVER_TEAL = '#011627'

export const SOMEWHERE_GOOD_GRADIENT_ONE =
  'linear-gradient(90deg, #FBECDA 0%,  #FFD4D4 40%, #FFD4D4 100%)'
export const SOMEWHERE_GOOD_MOBILE_GRADIENT_ONE =
  'linear-gradient(180deg, #FBECDA 0%,  #FFD4D4 40%, #FFD4D4 100%)'

export const themeMap = {
  [THEME_GREY]: STUDIO_GREY,
  [THEME_WHITE]: STUDIO_WHITE,
  [THEME_RED]: STUDIO_RED,
}

export const pageThemeMap = {
  [HOME_ROUTE]: {
    nextTheme: THEME_WHITE,
    nextLogoTheme: THEME_GREY,
  },
}

const SPIRITUNE_CIRCLE_FACTOR_DESKTOP_0 = 0.46
const SPIRITUNE_CIRCLE_FACTOR_MOBILE_0 = 0.78
const SPIRITUNE_CIRCLE_FACTOR_DESKTOP_1 = 0.68
const SPIRITUNE_CIRCLE_FACTOR_MOBILE_1 = 1.15
const SPIRITUNE_CIRCLE_FACTOR_DESKTOP_2 = 0.7625
const SPIRITUNE_CIRCLE_FACTOR_MOBILE_2 = 1.64
const SPIRITUNE_CIRCLE_FACTOR_DESKTOP_3 = 1.23
const SPIRITUNE_CIRCLE_FACTOR_MOBILE_3 = 2.432

const SPIRITUNE_CIRCLE_LEFT_DESKTOP_0 = -0.74
const SPIRITUNE_CIRCLE_LEFT_MOBILE_0 = -0.93
const SPIRITUNE_CIRCLE_LEFT_DESKTOP_1 = -0.66
const SPIRITUNE_CIRCLE_LEFT_MOBILE_1 = -0.79
const SPIRITUNE_CIRCLE_LEFT_DESKTOP_2 = 0.46
const SPIRITUNE_CIRCLE_LEFT_MOBILE_2 = 0.016
const SPIRITUNE_CIRCLE_LEFT_DESKTOP_3 = 0.15
const SPIRITUNE_CIRCLE_LEFT_MOBILE_3 = -0.15

const SPIRITUNE_CIRCLE_TOP_DESKTOP_0 = -0.73
const SPIRITUNE_CIRCLE_TOP_MOBILE_0 = -0.47
const SPIRITUNE_CIRCLE_TOP_DESKTOP_1 = -0.66
const SPIRITUNE_CIRCLE_TOP_MOBILE_1 = -0.48
const SPIRITUNE_CIRCLE_TOP_DESKTOP_2 = 0.2
const SPIRITUNE_CIRCLE_TOP_MOBILE_2 = 0.64
const SPIRITUNE_CIRCLE_TOP_DESKTOP_3 = -0.03
const SPIRITUNE_CIRCLE_TOP_MOBILE_3 = 0.245

export const SPIRITUNE_CIRCLE_COUNT = 4
export const SPIRITUNE_CIRCLE_FACTOR_MAP = {
  0: {
    desktop: SPIRITUNE_CIRCLE_FACTOR_DESKTOP_0,
    mobile: SPIRITUNE_CIRCLE_FACTOR_MOBILE_0,
    leftDesktop: SPIRITUNE_CIRCLE_LEFT_DESKTOP_0,
    topDesktop: SPIRITUNE_CIRCLE_TOP_DESKTOP_0,
    leftMobile: SPIRITUNE_CIRCLE_LEFT_MOBILE_0,
    topMobile: SPIRITUNE_CIRCLE_TOP_MOBILE_0,
  },
  1: {
    desktop: SPIRITUNE_CIRCLE_FACTOR_DESKTOP_1,
    mobile: SPIRITUNE_CIRCLE_FACTOR_MOBILE_1,
    leftDesktop: SPIRITUNE_CIRCLE_LEFT_DESKTOP_1,
    topDesktop: SPIRITUNE_CIRCLE_TOP_DESKTOP_1,
    leftMobile: SPIRITUNE_CIRCLE_LEFT_MOBILE_1,
    topMobile: SPIRITUNE_CIRCLE_TOP_MOBILE_1,
  },
  2: {
    desktop: SPIRITUNE_CIRCLE_FACTOR_DESKTOP_2,
    mobile: SPIRITUNE_CIRCLE_FACTOR_MOBILE_2,
    leftDesktop: SPIRITUNE_CIRCLE_LEFT_DESKTOP_2,
    topDesktop: SPIRITUNE_CIRCLE_TOP_DESKTOP_2,
    leftMobile: SPIRITUNE_CIRCLE_LEFT_MOBILE_2,
    topMobile: SPIRITUNE_CIRCLE_TOP_MOBILE_2,
  },
  3: {
    desktop: SPIRITUNE_CIRCLE_FACTOR_DESKTOP_3,
    mobile: SPIRITUNE_CIRCLE_FACTOR_MOBILE_3,
    leftDesktop: SPIRITUNE_CIRCLE_LEFT_DESKTOP_3,
    topDesktop: SPIRITUNE_CIRCLE_TOP_DESKTOP_3,
    leftMobile: SPIRITUNE_CIRCLE_LEFT_MOBILE_3,
    topMobile: SPIRITUNE_CIRCLE_TOP_MOBILE_3,
  },
}

export const rippleColorMap = [STUDIO_RED, STUDIO_MID_BLUE, STUDIO_DARK_BLUE]

// Theme Transitions
export const TRANSITION_DURATION = 300
export const fadeRightTransitionStyles = {
  entering: { opacity: 0, transform: 'translateX(-20px)' },
  entered: { opacity: 1, transform: 'translateX(0)' },
  exiting: { opacity: 1, transform: 'translateX(0)' },
  exited: { opacity: 0, transform: 'translateX(-20px)' },
}
export const fadeUpTransitionStyles = {
  entering: { opacity: 0, transform: 'translateY(20px)' },
  entered: { opacity: 1, transform: 'translateY(0)' },
  exiting: { opacity: 1, transform: 'translateY(0)' },
  exited: { opacity: 0, transform: 'translateY(20px)' },
}
export const leftTransitionStyles = {
  entering: { transform: 'translateX(100%)' },
  entered: { transform: 'translateX(0)' },
  exiting: { transform: 'translateX(0)' },
  exited: { transform: 'translateX(100%)' },
}
export const upTransitionStyles = {
  entering: { transform: 'translateY(10px)' },
  entered: { transform: 'translateX(0)' },
  exiting: { transform: 'translateX(0)' },
  exited: { transform: 'translateY(10px)' },
}
